export const fetchProducts = async (ids) => {
  const formData = new FormData();
  formData.append("action", "get_compare_products");

  ids.forEach((id) => formData.append("ids[]", id));

  const response = await fetch(ajaxurl, {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    throw new Error("Błąd pobierania produktów");
  }

  const { success, data } = await response.json();

  if (!success) {
    throw new Error("Błąd odpowiedzi AJAX");
  }

  return data;
};